import * as types from "../../actions/actionTypes";
import intialState from "../initialState";

const reducer = {
  [types.PERSONS_GET_SELF_STARTED]: (state) => ({
    ...state,
    self: { isLoading: true },
  }),
  [types.PERSONS_GET_SELF_REJECTED]: (state, message) => ({
    ...state,
    self: { isLoading: false, message },
  }),
  [types.PERSONS_GET_SELF_FULFILLED]: (state, p) => ({
    ...state,
    self: { isLoading: false },
    [p._id]: { isLoading: false },
  }),

  [types.SHIFTS_GET_SHIFT_FULFILLED]: (state, payload) => ({
    ...state,
    ...payload.persons.map((p) => ({ [p._id]: { isLoading: false } })),
  }),

  [types.PERSONS_GET_PERSONS_BY_IDS_STARTED]: (state, ids) => ({
    ...state,
    ...ids.map((id) => ({ [id]: { isLoading: true } })),
  }),
  [types.PERSONS_GET_PERSONS_BY_IDS_FULFILLED]: (state, persons) => ({
    ...state,
    ...persons.map((p) => ({ [p._id]: { isLoading: false } })),
  }),
  [types.PERSONS_GET_PERSONS_BY_IDS_REJECTED]: (state, { message, ids }) => ({
    ...state,
    ...ids.map((id) => ({ [id]: { isLoading: false, message } })),
  }),

  [types.PERSONS_GET_PERSONS_BY_ASSOCIATION_STARTED]: (
    state,
    associationId,
  ) => ({
    ...state,
    associations: {
      ...state.associations,
      [associationId]: { isLoading: true },
    },
  }),
  [types.PERSONS_GET_PERSONS_BY_ASSOCIATION_FULFILLED]: (
    state,
    { associationId, persons },
  ) => ({
    ...state,
    [associationId]: { isLoading: false },
    ...persons.map((p) => ({ [p._id]: { isLoading: false } })),
  }),
  [types.PERSONS_GET_PERSONS_BY_ASSOCIATION_REJECTED]: (
    state,
    { associationId, message },
  ) => ({ ...state, [associationId]: { isLoading: false, message } }),
};

export default function personsReducer(state = intialState.persons, action) {
  return action.type in reducer
    ? reducer[action.type](state, action.payload)
    : state;
}
